export default async (commit, query) => {
    const purchaseInfo = {};
    const userInfo = {};
    const cartInfo = {
        selectedAddons: [],
        selectedCharges: [],
        installments: {},
    };

    // Legacy param support
    if (query.has('promoCode')) cartInfo.coupons = [query.get('promoCode')];
    if (query.has('edition')) purchaseInfo.planEdition = query.get('edition');
    if (query.has('edition') && !query.has('selectedBillingPeriod')) {
        cartInfo.selectedBillingPeriod = '1 month';
        cartInfo.billingPeriod = 'month';
    }
    // End Legacy param support

    if (query.has('partnerAccountId')) {
        purchaseInfo.partnerAccountId = query.get('partnerAccountId');
        if (query.has('bundleId')) purchaseInfo.bundleId = query.get('bundleId');
    }

    if (query.has('eventId')) {
        purchaseInfo.eventId = query.get('eventId');
    }

    if (query.has('quoteId')) purchaseInfo.quoteId = query.get('quoteId');
    if (query.has('linkPostedBy')) purchaseInfo.linkPostedBy = query.get('linkPostedBy');
    if (query.has('sourceCode')) purchaseInfo.sourceCode = query.get('sourceCode').toLowerCase();
    if (query.has('partnerName')) purchaseInfo.partnerName = query.get('partnerName').toLowerCase();
    if (query.has('purchaseLinkId')) purchaseInfo.purchaseLinkId = query.get('purchaseLinkId');
    if (query.has('channel')) purchaseInfo.channel = query.get('channel');

    if (query.has('toggle')) purchaseInfo.billingToggle = query.get('toggle') === 'true' ? true : false;
    if (query.has('influencer')) purchaseInfo.isInfluencer = query.get('influencer') === 'true' ? true : false;

    if (query.has('contacts')) purchaseInfo.contacts = parseInt(query.get('contacts'), 10);
    if (query.has('users')) purchaseInfo.users = parseInt(query.get('users'), 10);

    if (!userInfo.country || ['us', 'ca'].includes(userInfo.country.toLowerCase())) {
        if (query.has('msgBundle')) purchaseInfo.additionalMessages = parseInt(query.get('msgBundle'), 10);
        if (query.has('msgVoice')) purchaseInfo.textVoiceTier = parseInt(query.get('msgVoice'), 10);
        if (query.has('kbl')) {
            cartInfo.selectedAddons.push({
                itemId: query.get('kbl'),
                quantity: 1,
            });
        };
    }

    if (query.has('currency')) userInfo.currency = query.get('currency').toUpperCase();
    if (query.has('country')) userInfo.country = query.get('country');
    if (query.has('customerId')) userInfo.customerId = query.get('customerId');
    if (query.has('subscriptionId')) userInfo.subscriptionId = query.get('subscriptionId');

    if (query.has('kickstart')) {
        purchaseInfo.kickstartId = query.get('kickstart');
    }

    if (query.has('letsGrowOnboarding')) {
        cartInfo.selectedCharges.push({
            itemId: query.get('letsGrowOnboarding'),
            quantity: 1,
        });
    }

    if (query.has('service')) {
        cartInfo.selectedCharges.push({
            itemId: query.get('service'),
            quantity: 1,
        });
    }

    if (query.has('bookPackage')) {
        cartInfo.selectedCharges.push({
            itemId: query.get('bookPackage'),
            quantity: 1,
        });
    }

    if (query.has('couponCodes')) {
        if (!!cartInfo.coupons && cartInfo.coupons.length > 0) {
            cartInfo.coupons = [
                ...cartInfo.coupons,
                ...query.getAll('couponCodes')
            ]
        } else {
            cartInfo.coupons = query.getAll('couponCodes');
        }
        cartInfo.coupons = cartInfo.coupons.filter(coupon => {
            return !!coupon;
        });
    }

    if (query.has('numberOfInstallments') || query.has('installments')) {
        let installments = query.get('numberOfInstallments') || query.get('installments');
        if (typeof installments === 'string') {
            installments = parseInt(installments);
        }
        if (installments > 1) {
            cartInfo.installments.count = installments;
            cartInfo.installments.enabled = true;

            cartInfo.selectedCharges.push({
                itemId: 'Installment-Charge',
                quantity: 1,
            });
        }
    }

    if (!cartInfo.coupons || cartInfo.coupons.length <= 0) {
        cartInfo.coupons = ['CURRENT'];
    }

    if (query.has('selectedBillingPeriod')) {
        cartInfo.selectedBillingPeriod = query.get('selectedBillingPeriod');
        if (cartInfo.selectedBillingPeriod.split(' ')[1] == 'month') {
            cartInfo.billingPeriod = 'month';
        } else if (cartInfo.selectedBillingPeriod.split(' ')[1] == 'year') {
            cartInfo.billingPeriod = 'year';
        }
    }

    if (query.has('plan')) cartInfo.selectedPlanId = query.get('plan');
    if (query.has('aug')) {
        // url decode string
        let augString = decodeURIComponent(query.get('aug'));
        // base64 decode and JSON encode
        let augObj;

        try {
            augObj = JSON.parse(
                augString = atob(augString)
            );
        } catch (error) {
            window.Sentry.logError(error, {
                raw_aug: query.get('aug'),
                aug_string: augString
            });
            commit('setLinkError', true);
        }

        // set state to show T&C and / or ETF
        if (augObj.opts) {
            purchaseInfo.showEtf = augObj.opts.etf || false;
            purchaseInfo.showTc = augObj.opts.tc || false;
            purchaseInfo.showMbg90 = augObj.opts.mbg90 || false;
        }

        if (augObj.prefill) {
            userInfo.company = augObj.prefill.company || '';
            userInfo.email = augObj.prefill.email || '';
            userInfo.firstName = augObj.prefill.firstName || '';
            userInfo.lastName = augObj.prefill.lastName || '';
            userInfo.phone = augObj.prefill.phone || '';
        }
    }

    if (query.has('token')) purchaseInfo.token = query.get('token');

    if (!!purchaseInfo.token) {
        commit('setIsSelfUpgrading', true);
    }
    if (
        !!purchaseInfo.token
        || (
            !!userInfo.subscriptionId
            && (
                !!purchaseInfo.partnerAccountId
                || !!purchaseInfo.purchaseLinkId
            )
        )
    ) {
        commit('setIsUpgrading', true);
    } else if (
        !userInfo.subscriptionId
        && !!userInfo.customerId
        && (
            !!purchaseInfo.partnerAccountId
            || !!purchaseInfo.purchaseLinkId
        )
    ) {
        commit('setIsAddingSub', true);
    }

    if (query.has('charge')) {
        const charges = query.getAll('charge');
        charges.forEach(charge => {
            charge = charge.split(':');
            if (!!charge[1] && charge[1] <= 0) {
                return;
            }
            cartInfo.selectedCharges.push({
                itemId: charge[0],
                quantity: parseInt(charge[1], 10) || 1,
            });
        });
    }

    if (query.has('addon')) {
        const addons = query.getAll('addon');
        addons.forEach(addon => {
            addon = addon.split(':');
            if (!!addon[1] && addon[1] <= 0) {
                return;
            }
            cartInfo.selectedAddons.push({
                itemId: addon[0],
                quantity: parseInt(addon[1], 10) || 1,
            });
        });
    }

    if (cartInfo.selectedCharges.length > 0) {
        const uniqueCharges = [];
        const chargeIds = [];
        cartInfo.selectedCharges.forEach(charge => {
            if (!chargeIds.includes(charge.itemId)) {
                chargeIds.push(charge.itemId);
                uniqueCharges.push(charge);
            }
        });
        cartInfo.selectedCharges = uniqueCharges;
    }
    if (cartInfo.selectedAddons.length > 0) {
        const uniqueAddons = [];
        const addonIds = [];
        cartInfo.selectedAddons.forEach(addon => {
            if (!addonIds.includes(addon.itemId)) {
                addonIds.push(addon.itemId);
                uniqueAddons.push(addon);
            }
        });
        cartInfo.selectedAddons = uniqueAddons;
    }

    // Commit everything
    if (Object.keys(purchaseInfo).length > 0) {
        await commit('updatePurchaseInfo', purchaseInfo);
    }
    if (Object.keys(userInfo).length > 0) {
        await commit('updateUserInfo', userInfo);
    }
    if (Object.keys(cartInfo).length > 0) {
        await commit('updateCartInfo', cartInfo);
    }
}
